// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"98d967b7","217":"cca20868","238":"be282f04","331":"98d967b7","399":"fbb3d3ae","743":"b4f3a5a1","844":"005b5f5c","906":"47be5b6b","932":"bfa381ca","941":"f2fb0a68"}[chunkId] + ".chunk.css";
};